import * as actionsType from "../actions/types";

const initialState = {
    categories: null
};

export default function featuredProductsReducer(state = initialState, action) {
    const tempState = { ...state };
    switch (action.type) {
        case actionsType.SET_CATEGORIES:
           
            const { categoryList } = action.payload;
            return { ...state, categories: categoryList };
        case actionsType.SET_SUB_CATEGORIES:
            const { subCategoryList, categoryIndex } = action.payload;
            tempState.categories[categoryIndex] = { ...tempState.categories[categoryIndex], subCategories: subCategoryList };
            return tempState;
        case actionsType.SET_FEATURED_PRODUCTS:
            const { list, catIndex, subCategoryIndex } = action.payload;
            tempState.categories[catIndex].subCategories[subCategoryIndex] = { ...tempState.categories[catIndex].subCategories[subCategoryIndex], productsList: list };
            return tempState;
        default:
            return state;
    }
}